export default __webpack_public_path__ + "static/media/list.d4f2d3b2.svg";